/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskRubricInput } from './taskRubricInput';

export type TaskCreateRequestRubric = TaskRubricInput | null;
